import React, { Component } from 'react';
import { Provider } from 'react-redux';

import './App.scss';

import { Routes } from '../_routing/routes';
import { AppData } from '../common';

import { RootContextProvider } from '../../contexts/RootContext';
import store from '../../redux/store';
import packageInfo from '../../volt-package.json';

const getVersion = () => {
  if (packageInfo.version === 'local') {
    return packageInfo.version;
  }
  return `v${packageInfo.version}`;
};

class App extends Component<any, any> {
  render() {
    return (
      <Provider store={store}>
        <RootContextProvider>
          <div className='appComponent'>
            <Routes />
            <AppData appVersion={getVersion()} />
          </div>
        </RootContextProvider>
      </Provider>
    );
  }
}

export default App;
